import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Crypto Redux States
import { PASSWORD_CHANGE, UPDATE_PROFILE, UPDATE_PROFILE_IMAGE } from "./actionTypes";
import { loginPasswordChangeSuccess, loginPasswordChangeError, updateProfileError, updateProfileSuccess, updateProfileImageSuccess, updateProfileImageError, updateProfileImageLoading } from "./actions";

//Include Both Helper File with needed methods
import {
    updateProfile,
    changeLoginPassword,
    updateProfileImg
}
    from "../../helpers/backend_helper";
import toast from "react-hot-toast";

// update profile
function* UpdateProfile({ payload: { user, history, id } }) {
    try {
        const data = {}
        data["firstName"] = user.firstName
        data["lastName"] = user.lastName
        data["phoneNumber"] = user.phoneNumber
        data["userId"] = id
        const response = yield call(updateProfile, data)
        if (response.status === 'ERROR') {
            toast.error(response.message)
        } else if (response.status === "SUCCESS") {
            toast.success(response.message)
            yield put(updateProfileSuccess(response))
            localStorage.setItem("authUser", JSON.stringify({ user: response.data }))
        }
    } catch (error) {
        yield put(updateProfileError(error))
        toast.error(error.response.data.message)
    }
}

export function* UpdateProfileSaga() {
    yield takeEvery(UPDATE_PROFILE, UpdateProfile)
}

// password change
function* LoginPasswordChange({ payload: { data, history } }) {
    try {
        const response = yield call(changeLoginPassword, data)
        if (response.status === 'error') {
            yield put(loginPasswordChangeError(response))
            toast.error(response.message)
        } else {
            toast.success(response.message)
            yield put(loginPasswordChangeSuccess(response))
        }
    } catch (error) {
        yield put(loginPasswordChangeError(error))
        toast.error(error.response.data.message)
    }
}

export function* LoginPasswordChangeSaga() {
    yield takeEvery(PASSWORD_CHANGE, LoginPasswordChange)
}

// update profile image
function* UpdateProfileImg({ payload: data }) {
    const img = {}
    img['profileImg'] = data
    try {
        yield put(updateProfileImageLoading(true))
        const response = yield call(updateProfileImg, img)
        if (response.status === 'ERROR') {
            toast.error(response.message)
        } else {
            toast.success(response.message)
            yield put(updateProfileImageSuccess(response))
            localStorage.setItem("authUser", JSON.stringify({ user: response.data }))
        }
        yield put(updateProfileImageLoading(false))
    } catch (error) {
        yield put(updateProfileImageError(error))
    }
}

export function* UpdateProfileImageSaga() {
    yield takeEvery(UPDATE_PROFILE_IMAGE, UpdateProfileImg)
}